export const type = 'hideModalGenerico';

const hideModalGenerico = (accion) => ({
    type,
    payload: new Date(),
    accion:accion,
});

export default hideModalGenerico;